import {isEmpty, isNil} from "ramda";

import {AnyObject} from "~/model/helperTypes/generic";

export const removePropFromNestedObject = <T extends AnyObject>(propName: string, obj: T) => {
  Object.keys(obj).forEach(
    (key) =>
      (key === propName && delete obj[key]) ||
      (obj[key] && typeof obj[key] === "object" && removePropFromNestedObject(propName, obj[key])),
  );
  return obj;
};

export const removeNilFromNestedObject = <T extends AnyObject>(obj: T) => {
  Object.keys(obj).forEach(
    (key) =>
      (isNil(obj[key]) && delete obj[key]) ||
      (obj[key] && typeof obj[key] === "object" && removeNilFromNestedObject(obj[key])),
  );
  return obj;
};

// pay attention that it removes only empy Objects and Arrays!
// primitives are not touched
export const removeEmptyFromNestedObject = <T extends AnyObject>(obj: T) => {
  Object.keys(obj).forEach(
    (key) =>
      (isEmpty(obj[key]) && delete obj[key]) ||
      (obj[key] && typeof obj[key] === "object" && removeEmptyFromNestedObject(obj[key])),
  );
  return obj;
};
